module.exports = {"610925100":"城关镇","610925101":"佐龙镇","610925103":"滔河镇","610925104":"官元镇","610925105":"石门镇","610925106":"民主镇","610925107":"大道河镇","610925109":"堰门镇","610925111":"蔺河镇","610925112":"四季镇","610925114":"孟石岭镇","610925115":"南宫山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610925.json
// module id = 3016
// module chunks = 0